import { NavItem } from '@/common/types'
import {
	Activity,
	BarChartIcon,
	DicesIcon,
	Gamepad2Icon,
	HandCoinsIcon,
	HomeIcon,
	LandmarkIcon,
	MessageCircle,
	MessageSquareIcon,
	SettingsIcon,
	ShieldIcon,
	ShoppingCartIcon,
	TagIcon,
	TicketIcon,
	TicketsIcon,
	TrophyIcon,
	UserIcon,
	UsersIcon,
	Wallet,
} from 'lucide-react'
import { PermissionKeys } from '../manage-member/mappers'

export const navItems: NavItem[] = [
	{
		title: 'หน้าแรก',
		url: '/operator/home-page',
		icon: <HomeIcon />,
		isActive: false,
	},
	{
		title: 'จัดการกิจกรรม',
		url: '/operator/events',
		icon: <TicketIcon />,
		isActive: false,
		permissions: [PermissionKeys.WEB_SETTING],
	},
	{
		title: 'ผู้ดูแลระบบ',
		url: '#',
		icon: <UserIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_OPERATOR],
		items: [
			{
				title: 'จัดการผู้ดูแลระบบ',
				url: '/operator/manage-member',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_OPERATOR],
			},
			{
				title: 'ประเภทผู้ดูแลระบบ',
				url: '/operator/member-group-list',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_OPERATOR],
			},
			{
				title: 'ประวัติการเข้าสู่ระบบ',
				url: '/operator/member-login-log',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_OPERATOR],
			},
			{
				title: 'ประวัติการทำรายการ',
				url: '/operator/event-log',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_OPERATOR],
			},
		],
	},
	{
		title: 'แชท LINE',
		url: '#',
		icon: <MessageCircle />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_CHAT],
		badgeKey: 'chatUnreadCount',
		items: [
			{
				title: 'แชท',
				url: '/operator/chat',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
				badgeKey: 'chatUnreadCount',
			},
			{
				title: 'ตั้งค่าแชท',
				url: '/operator/chat/settings',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
			},
			{
				title: 'สถิติแชท',
				url: '/operator/chat/analytics',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
			},
			{
				title: 'แชทที่ถูกระงับ',
				url: '/operator/chat/banned',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
			},
			{
				title: 'แชทที่ถูกปิด',
				url: '/operator/chat/closed',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
			},
			{
				title: 'Broadcast ข้อความ',
				url: '/operator/chat/broadcast',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
			},
			{
				title: 'ประวัติส่งข้อความอัตโนมัติ',
				url: '/operator/line-message-log',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_CHAT],
			},
		],
	},
	{
		title: 'สมาชิกบนเว็บ',
		url: '#',
		icon: <UsersIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_PLAYER, PermissionKeys.MANAGE_INVITE],
		items: [
			{
				title: 'จัดการสมาชิก',
				url: '/operator/get-player-list',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'ข้อมูลรายได้ผู้เล่น',
				url: '/operator/get-player-data',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'สมาชิกที่มียอดฝาก',
				url: '/operator/player-with-deposit',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'สมาชิกที่มียอดฝากโปรโมชั่น',
				url: '/operator/player-with-deposit-promotion',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'สมาชิกที่มียอดถอน',
				url: '/operator/player-with-withdraw',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'สมาชิกที่มีการเคลื่อนไหว',
				url: '/operator/active-player-list',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'สมาชิกที่ถูกแบน',
				url: '/operator/banned-player',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'สมาชิกที่เลิกเล่น',
				url: '/operator/inactive-player',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'พาร์ทเนอร์',
				url: '/operator/partner',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
			{
				title: 'ประวัติจ่ายส่วนแบ่งพาร์ทเนอร์',
				url: '/operator/partner-payments',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_PLAYER],
			},
		],
	},
	{
		title: 'จัดการแท็กผู้เล่น',
		url: '/operator/tags',
		icon: <TagIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_PLAYER],
	},
	{
		title: 'ตั้งค่าช่องทางที่รู้จัก',
		url: '/operator/get-channel',
		isActive: false,
		permissions: [PermissionKeys.MANAGE_PLAYER],
	},
	{
		title: 'จัดการธนาคาร',
		url: '#',
		icon: <LandmarkIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_BANK_ACCOUNT],
		items: [
			{
				title: 'รายการบัญชีธนาคาร',
				url: '/operator/bank-account',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_ACCOUNT],
			},
			{
				title: 'ธนาคารออโต้',
				url: '/operator/payment-gateway',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_ACCOUNT],
			},
			{
				title: 'รายการฝากตรง',
				url: '/operator/payment-gateway/deposits',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_ACCOUNT],
			},
			{
				title: 'รายการถอนตรง',
				url: '/operator/payment-gateway/withdrawals',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_ACCOUNT],
			},
			{
				title: 'สรุปภาพรวมธนาคาร',
				url: '/operator/bank-overview',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_ACCOUNT],
			},
		],
	},
	{
		title: 'ธุรกรรม',
		url: '#',
		icon: <HandCoinsIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
		badgeKey: 'pendingWithdrawalsCount',
		items: [
			{
				title: 'รายการฝากเงิน',
				url: '/operator/transactions/deposits',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
			},
			{
				title: 'รายการถอนเงิน',
				url: '/operator/transactions/withdraws',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
				badgeKey: 'pendingWithdrawalsCount',
			},
			{
				title: 'ประวัติทรูวอลเล็ต',
				url: '/operator/transactions/true-wallet-logs',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
			},
			{
				title: 'ประวัติ SMS แจ้งเตือน',
				url: '/operator/transactions/sms-auto-logs',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
			},
			{
				title: 'ตั้งค่าการฝากเงิน',
				url: '/operator/transaction-settings/deposit',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
			},
			{
				title: 'ตั้งค่าการถอนเงิน',
				url: '/operator/transaction-settings/withdraw',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_BANK_TRANSACTION],
			},
		],
	},
	{
		title: 'สรุปภาพรวม',
		url: '#',
		icon: <BarChartIcon />,
		isActive: false,
		permissions: [
			PermissionKeys.MANAGE_MARKETING,
			PermissionKeys.MANAGE_CHANNEL_ANALYTICS,
		],
		items: [
			{
				title: 'สรุปภาพรวม',
				url: '/operator/overall-analytic',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_MARKETING],
			},
			// {
			// 	title: 'สรุปยอดฝากถอน',
			// 	url: '/operator/graph-summary',
			// 	isActive: false,
			// 	permissions: [PermissionKeys.MANAGE_MARKETING],
			// },
			{
				title: 'ค่าเฉลี่ยตามแหล่งที่มา',
				url: '/operator/channel-analytic',
				isActive: false,
				permissions: [
					PermissionKeys.MANAGE_MARKETING,
					PermissionKeys.MANAGE_CHANNEL_ANALYTICS,
				],
			},
			{
				title: 'วิเคราะห์โปรโมชั่น',
				url: '/operator/promotion-analytic',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_MARKETING],
			},
			{
				title: 'วิเคราะห์ Retention',
				url: '/operator/retention-analytics',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_MARKETING],
			},
			{
				title: 'ประวัติการเล่น',
				url: '/operator/play-logs',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_MARKETING],
			},
			{
				title: 'สถิติการเล่นเกม',
				url: '/operator/player-game-stats',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_MARKETING],
			},
			{
				title: 'ผู้ใช้งานออนไลน์',
				url: '/operator/active-users',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_MARKETING],
			},
		],
	},
	{
		title: 'โปรโมชั่น',
		url: '#',
		icon: <TicketsIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_DEPOSIT_PROMOTION],
		items: [
			{
				title: 'รายการโปรโมชั่น',
				url: '/operator/deposit-promotion',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_DEPOSIT_PROMOTION],
			},
		],
	},
	{
		title: 'กิจกรรม',
		url: '#',
		icon: <DicesIcon />,
		isActive: false,
		permissions: [
			PermissionKeys.MANAGE_COMMISSION_CASHBACK,
			PermissionKeys.MANAGE_RETURN_LOSS,
			PermissionKeys.MANAGE_DAILY_CHECK_IN,
			PermissionKeys.MANAGE_LUCKY_WHEEL,
			PermissionKeys.MANAGE_INVITE,
			PermissionKeys.MANAGE_PLAYER,
			PermissionKeys.MANAGE_DEPOSIT_PROMOTION,
		],
		items: [
			{
				title: 'รายการคอมมิชชั่น',
				url: '/operator/commission',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_COMMISSION_CASHBACK],
			},
			{
				title: 'รายการคืนยอดเสีย',
				url: '/operator/return-loss',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_RETURN_LOSS],
			},
			{
				title: 'ยอดเสียรายวันของผู้เล่น',
				url: '/operator/return-loss/daily-player-return-loss',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_RETURN_LOSS],
			},
			{
				title: 'ประวัติการคืนยอดเสีย',
				url: '/operator/return-loss/history',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_RETURN_LOSS],
			},
			{
				title: 'เช็คอินรายวัน',
				url: '/operator/daily-check-in',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_DAILY_CHECK_IN],
			},
			{
				title: 'รายการกงล้อ',
				url: '/operator/lucky-wheel',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_LUCKY_WHEEL],
			},
			{
				title: 'ตั้งค่าการชวนเพื่อน',
				url: '/operator/invite-friend',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_INVITE],
			},
			{
				title: 'ประวัติคอมมิชชั่นชวนเพื่อน',
				url: '/operator/invite-friend/commission-history',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_INVITE],
			},
		],
	},
	{
		title: 'คูปอง',
		url: '/operator/coupons',
		icon: <TicketIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_COUPON],
	},
	{
		title: 'ร้านค้า',
		url: '#',
		icon: <ShoppingCartIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_SHOP],
		items: [
			{
				title: 'จัดการสินค้า',
				url: '/operator/shop/items',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SHOP],
			},
			{
				title: 'ประวัติการซื้อ',
				url: '/operator/shop/purchases',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SHOP],
			},
			{
				title: 'คำสั่งซื้อที่รอดำเนินการ',
				url: '/operator/shop/purchases/pending',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SHOP],
			},
		],
	},
	{
		title: 'Rank',
		url: '#',
		icon: <ShieldIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_RANK],
		items: [
			{
				title: 'รายการ Rank',
				url: '/operator/rank',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_RANK],
			},
			{
				title: 'ตั้งค่าคะแนนประสบการณ์',
				url: '/operator/rank-settings',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_RANK],
			},
		],
	},
	{
		title: 'ตั้งค่าเว็บ',
		url: '#',
		icon: <SettingsIcon />,
		isActive: false,
		permissions: [PermissionKeys.WEB_SETTING],
		items: [
			{
				title: 'ตั้งค่าทั่วไป',
				url: '/operator/general-setting',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าแบรนด์เว็บไซต์',
				url: '/operator/website-branding',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าธุรกรรม',
				url: '/operator/transaction-setting',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าฝากไม่รับโปร',
				url: '/operator/main-wallet-setting',
				icon: <LandmarkIcon />,
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าช่องทางติดต่อ',
				url: '/operator/contact-setting',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่ารูปสไลด์หน้าเว็บ',
				url: '/operator/carousel',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าประกาศผู้เล่นเงินหมด',
				url: '/operator/broke-notification',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าประกาศ',
				url: '/operator/login-announce',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าประกาศสไลด์หน้าเว็บ',
				url: '/operator/slide-announcement',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'เทมเพลตหน้าเว็บ',
				url: '/operator/dynamic-page-presets',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่า section',
				url: '/operator/dynamic-section',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าหน้าเว็บ',
				url: '/operator/dynamic-page',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'จัดการปุ่มทางเข้าเกม',
				url: '/operator/profile-page-banner',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'จัดการโดเมน',
				url: '/operator/manage-domains',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'จัดการเซสชัน',
				url: '/operator/session-management',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ตั้งค่าแจ้งเตือนเทเลแกรม',
				url: '/operator/telegram-notify',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
			{
				title: 'ผู้ให้บริการ OTP',
				url: '/operator/otp-provider',
				isActive: false,
				permissions: [PermissionKeys.WEB_SETTING],
			},
		],
	},
	{
		title: 'ตั้งค่าเกม',
		url: '#',
		icon: <Gamepad2Icon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_GAME],
		items: [
			{
				title: 'รายชื่อเกมและการตั้งค่า',
				url: '/operator/game-list',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_GAME],
			},
			{
				title: 'รายชื่อประเภทเกมและการตั้งค่า',
				url: '/operator/game-type',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_GAME],
			},
			{
				title: 'รายชื่อค่ายเกมและการตั้งค่า',
				url: '/operator/provider-list',
				icon: <Gamepad2Icon />,
				isActive: false,
				permissions: [PermissionKeys.MANAGE_GAME],
			},
		],
	},
	{
		title: 'ทัวร์นาเมนต์',
		url: '/operator/tournaments',
		icon: <TrophyIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_GAME],
	},
	{
		title: 'รายการ Blacklist',
		url: '/operator/blacklist',
		icon: <ShieldIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_BLACKLIST],
	},
	{
		title: 'ส่งข้อความ',
		url: '#',
		icon: <MessageSquareIcon />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_SMS],
		items: [
			{
				title: 'ส่งข้อความ',
				url: '/operator/messaging/create',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'รายการส่งข้อความ',
				url: '/operator/messaging/campaigns',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'สร้างข้อความอัตโนมัติ',
				url: '/operator/messaging/auto/create',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'จัดการข้อความอัตโนมัติ',
				url: '/operator/messaging/auto',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'สร้างข้อความตามช่วงเวลา',
				url: '/operator/messaging/interval/create',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'จัดการข้อความตามช่วงเวลา',
				url: '/operator/messaging/interval',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'จัดการแคมเปญข้อความเงินหมด (LINE)',
				url: '/operator/messaging/broke-flex-message',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'ประวัติการส่งข้อความ',
				url: '/operator/messaging/transactions',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'จัดการ Flex Message',
				url: '/operator/settings/flex-hot-games',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'โควต้าการใช้งานไลน์',
				url: '/operator/line-analytics',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'วิเคราะห์ผลการส่งข้อความ',
				url: '/operator/messaging/analytics',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'วิเคราะห์ Flex Message',
				url: '/operator/messaging/flex-analytics',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
			{
				title: 'วิเคราะห์ Broke-Flex Campaign',
				url: '/operator/messaging/broke-flex-analytics',
				isActive: false,
				permissions: [PermissionKeys.MANAGE_SMS],
			},
		],
	},
	{
		title: 'ใบแจ้งหนี้',
		url: '/operator/crypto-invoices',
		icon: <Wallet />,
		isActive: false,
	},
	{
		title: 'ตัวชี้วัดระบบ',
		url: '/operator/system-metrics',
		icon: <Activity />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_SERVER_METRICS],
	},
	{
		title: 'จัดการโควต้า',
		url: '/operator/quota',
		icon: <Wallet />,
		isActive: false,
		permissions: [PermissionKeys.MANAGE_OPERATOR],
	},
	{
		title: 'หน้าโปรไฟล์',
		url: '/operator/profile',
		icon: <UserIcon />,
		isActive: false,
	},
]
